import useTranslate from "hooks/useTranslate";
import classNames from "classnames";
import { LOYALTY_RANK_TAG_STATUSES } from "./constants";
import { LoyaltyTagStatusVariantT } from "./types";
import "./styles.sass";

type LoyaltyTagStatusRankProps = {
  status: LoyaltyTagStatusVariantT;
};

const LoyaltyTagStatusRank = ({ status }: LoyaltyTagStatusRankProps) => {
  const t = useTranslate();
  const text = t(LOYALTY_RANK_TAG_STATUSES[status]);

  const classNameTag = classNames(
    "LoyaltyTagStatusRank",
    `LoyaltyTagStatusRank_${status}`,
  );
  return <div className={classNameTag}>{text}</div>;
};

export default LoyaltyTagStatusRank;
